/**
 * Request builders for custom item endpoints not covered by generic JSON:API utilities.
 */

export function getItemStats(id: string) {
  return { url: `/api/items/${encodeURIComponent(id)}/stats` };
}

export function getMentionsForItem(id: string) {
  return { url: `/api/mentions?filter[itemId]=${encodeURIComponent(id)}` };
}
